import { styled } from "@mui/material";
import { NavLink } from "react-router-dom";

export const StyledWrapper = styled("div")(({ theme }) => ({
  borderBottom: "1px solid var(--black)",
  display: "inline-flex",
  marginBottom: theme.spacing(5.5),
  padding: "0x",
  width: "auto",

  '[data-theme="dark"] &': {
    borderBottomColor: "var(--white)",
  },
}));

export const StyledItem = styled("span")(({ theme }) => ({
  color: "var(--black)",
  display: "inline-block",
  position: "relative",
  padding: "0",

  "&::after": {
    backgroundColor: "currentcolor",
    borderRadius: "3px 3px 0 0",
    bottom: "-6px",
    content: '""',
    position: "absolute",
    height: "0",
    left: "0",
    right: "0",
    transition: "height .2s ease",
  },

  "&.active, &:hover": {
    color: theme.palette.primary.main,
  },
  "&.active::after, &:hover::after": {
    height: "3px",
  },

  '[data-theme="dark"] &': {
    color: "var(--white)",
  },
}));

export const StyledLink = styled(NavLink)(({ theme }) => ({
  display: "inline-block",
  fontWeight: 500,
  fontSize: "clamp(20px, 5vw, 32px)",
  textDecoration: "none",
  padding: `6px ${theme.spacing(2)}`,

  "@media (min-width: 640px)": {
    padding: `6px ${theme.spacing(4)}`,
  },
}));
